import { useSelector } from 'react-redux';
import {
  AuroraChip,
  AuroraChipProps,
} from '@rossum/components/aurora-chip/AuroraChip';
import { poweredByAuroraSelector } from '../../redux/modules/organization/selectors';

const ConditionalAuroraChip = (props: AuroraChipProps) => {
  const auroraPromoVisible = useSelector(poweredByAuroraSelector);

  if (!auroraPromoVisible) {
    return null;
  }

  return <AuroraChip {...props} />;
};

export default ConditionalAuroraChip;
